import { Link } from "react-router-dom";
import Footer from "../../Layouts/Footer";

const ReturnPolicy = () => {
  return (
    <>
      {/* <Header /> */}
      <div id="ajax-content-wrap">
        <div className="breadcrumb">
          <span>
            <span>
              <Link to="/">Home</Link> /{" "}
              <span className="breadcrumb_last" aria-current="page">
                Return Policy{" "}
              </span>
            </span>
          </span>{" "}
        </div>
        <div
          id="page-header-wrap"
          data-animate-in-effect="none"
          data-midnight="light"
          className=""
          style={{ height: "250px" }}
        >
          <div
            id="page-header-bg"
            className="not-loaded "
            data-padding-amt="low"
            data-animate-in-effect="none"
            data-midnight="light"
            data-text-effect="rotate_in"
            data-bg-pos="center"
            data-alignment="center"
            data-alignment-v="middle"
            data-parallax="0"
            data-height="250"
            style={{ backgroundColor: "#e8f5e5", height: "250px" }}
          >
            <div className="container">
              <div className="row">
                <div className="col span_6 ">
                  <div className="inner-wrap">
                    <h1 className="top-heading">
                      <span className="wraped">
                        <span
                          style={{
                            transform: "rotateX(0deg) translate(0px)",
                            opacity: 1,
                            color: "black",
                          }}
                        >
                          Return
                        </span>
                      </span>{" "}
                      <span className="wraped">
                        <span
                          style={{
                            transform: "rotateX(0deg) translate(0px)",
                            opacity: 1,
                            color: "black",
                          }}
                        >
                          Policy
                        </span>
                      </span>
                    </h1>{" "}
                    <span
                      className="subheader"
                      style={{
                        transform: "rotateX(0deg) translate(0px)",
                        opacity: 1,
                      }}
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-wrap" style={{ minHeight: "333px" }}>
          <div className="container main-content">
            <div className="row">
              <div
                id="about_us"
                data-column-margin="default"
                data-midnight="dark"
                className="wpb_row vc_row-fluid vc_row  vc_row-o-equal-height vc_row-flex   right_padding_85px left_padding_85px right_padding_tablet_65px right_padding_phone_20px left_padding_tablet_65px left_padding_phone_20px "
                style={{ paddingTop: "60px", paddingBottom: "0px" }}
              >
                <div
                  className="row-bg-wrap"
                  data-bg-animation="none"
                  data-bg-overlay="false"
                >
                  <div className="inner-wrap">
                    <div className="row-bg" style={{}}></div>
                  </div>
                </div>
                <div className="row_col_wrap_12 col span_12 dark left">
                  <div
                    className="vc_col-sm-12 wpb_column column_container vc_column_container col no-extra-padding inherit_tablet inherit_phone "
                    data-padding-pos="all"
                    data-has-bg-color="false"
                    data-bg-color=""
                    data-bg-opacity="1"
                    data-animation=""
                    data-delay="0"
                  >
                    <div className="vc_column-inner">
                      <div className="wpb_wrapper">
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p style={{ padding: "0px", textAlign: "left" }}>
                              <span
                                style={{ color: "#212529", fontSize: "16px" }}
                              >
                                <strong>1. INTRODUCTION</strong>
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "#212529" }}>
                                1.1 For purposes of this Return Policy, “we” or
                                “our” refers to LapOtencielle, LLC, and “you” or
                                “your” refers to the customer. Please read this
                                Return Policy carefully as it constitutes your
                                agreement with us.
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "#212529" }}>
                                1.2 By engaging us to provide our products, you
                                agree to be legally bound by this Return Policy.
                                We reserve the right to change or modify this
                                Return Policy at any time.
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "#212529" }}>
                                1.3 Unless otherwise specified, any changes or
                                modifications will be effective immediately and
                                your continued use of our services after such
                                time will constitute your acceptance of such
                                changes or modifications.
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p style={{ padding: "0px", textAlign: "left" }}>
                              <span
                                style={{ color: "#212529", fontSize: "16px" }}
                              >
                                <strong>2. RETURN</strong>
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "#212529" }}>
                                2.1 At LapOtencielle, LLC we do all we can to
                                meet your high expectations and stock products
                                you will love.
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "#212529" }}>
                                2.2 Kindly note that only products ordered
                                through our site will be eligible for a return.
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "#212529" }}>
                                2.3 The product needs to be on its original
                                packaging when returned.
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "#212529" }}>
                                2.4 We allow customers to return our products
                                within a period of 14 days in the event the
                                product is not as stipulated in the website, you
                                must send an email to us immediately. Kindly be
                                advised that the products should be returned
                                unopened and unused.
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "#212529" }}>
                                2.5 Kindly note that we will not indulge
                                requests that involve misuse of the product. You
                                understand that LapOtencielle, LLC has the
                                discretion to analyze and decide whether the
                                product is being used in a proper manner.
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "#212529" }}>
                                2.6 All refunds will be made to the debit or
                                credit card on which the original purchase was
                                made within 14 days of the cancellation of the
                                order or return of the products.
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="wpb_text_column wpb_content_element ">
                          <div className="wpb_wrapper">
                            <p style={{ padding: "0px", textAlign: "left" }}>
                              <span
                                style={{ color: "#212529", fontSize: "16px" }}
                              >
                                <strong>3. SEVERABILITY</strong>
                              </span>
                            </p>
                            <p>
                              <span style={{ color: "#212529" }}>
                                In the event any provision or part of this
                                Return Policy is found to be invalid or
                                unenforceable, only that particular provision or
                                part so found, and not the entire Return Policy,
                                will be inoperative.
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
        {/* Footer  */}
      </div>
    </>
  );
};

export default ReturnPolicy;
